<template>
  <div class="mt-10 sm:mt-0">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="flex px-4 sm:px-0">
          <h3 v-if="title" class="text-lg font-medium leading-6 text-gray-900">
            {{ title }}
          </h3>
          <span
            v-if="labelText"
            class="ml-2 inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-700/10"
            >{{ labelText }}</span
          >
          <HelpPopover v-if="helpPopoverText" :text="helpPopoverText" />
        </div>
      </div>
      <div class="mt-5 md:col-span-2 md:mt-0">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import HelpPopover from './HelpPopover.vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  helpPopoverText: {
    type: String,
    default: '',
  },
  labelText: {
    type: String,
    default: '',
  },
})
</script>
